module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module chunks = styles